/**
 * @file history对象
 * @author mengchen <sisimengchen@gmail.com>
 */
import { createBrowserHistory, createHashHistory } from 'history';
import routes from './routes';
import { UAParser } from '@utils';
import { lazyDingTalkSdk } from '@utils/lazylib';

export const historyMode = 'hashHistory'; // process.env.TARGET == 'githubpages' ? 'hashHistory' : 'browserHistory';

const createHistory =
  historyMode == 'hashHistory' ? createHashHistory : createBrowserHistory;

export const history = createHistory({
  getUserConfirmation: (message, callback) => callback(true),
  forceRefresh: false
});

export const listenCallback = (location, action) => {
  console.log(
    `The current URL is ${location.pathname}${location.search}${location.hash}`
  );
  console.log(`The last navigation action was ${action}`);
  routes.map(route => {
    if (
      location?.pathname?.toLocaleLowerCase() ==
      route?.path?.toLocaleLowerCase()
    ) {
      const userAgent = UAParser();
      if (userAgent?.DingTalk) {
        lazyDingTalkSdk().then(dd => {
          if (dd.env.platform !== 'notInDingTalk') {
            dd.biz.navigation.setTitle({
              title: route?.title
            });
          } else {
            document.title = route?.title;
          }
        });
      } else {
        document.title = route?.title;
      }
    }
  });
};

export const blockCallback = (location, action) => '测试文案';
